export default __webpack_public_path__ + "static/media/20210819182529.7e55f2e9.png";